import { LogManager } from '../../../common/port/log/log.manager.port';
import { AccountMetricsInsightsFocusV1SummaryEntityMapper } from '../../../infrastructure/mappers/challenge-insights/account-metrics-insights-focus-v1-summary.entity.mapper';
import { GetAccountMetricsInsightsFocusV1SummaryRequestDto } from '../../dtos/challenge-insights/get-account-metrics-insights-focus-v1-summary.request.dto';
import { GetAccountMetricsInsightsFocusV1SummaryResponseDto } from '../../dtos/challenge-insights/get-account-metrics-insights-focus-v1-summary.response.dto';
import { GetAccountMetricsInsightsFocusV1SummaryQuery } from '../../queries/challenge-insights/get-account-metrics-insights-focus-v1-summary.query';

export class GetAccountMetricsInsightsFocusV1SummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountMetricsInsightsFocusV1SummaryQuery,
    protected readonly mapper: AccountMetricsInsightsFocusV1SummaryEntityMapper
  ) {}

  async get(
    props: GetAccountMetricsInsightsFocusV1SummaryRequestDto
  ): Promise<GetAccountMetricsInsightsFocusV1SummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountMetricsInsightsFocusV1SummaryController.get encountered an error ${error}`
      );
    }
  }
}
